import { Typography } from "@mui/material";
import React, { useMemo } from "react";

const InfoItemLabel = ({
  children,
  fontSize,
  color = "#64748b",
  sx,
  variant = "caption",
}) => {
  const styles = useMemo(() => {
    return {
      fontSize: fontSize,
      color,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      fontWeight: 400,
      ...sx,
    };
  }, [sx, fontSize, color]);
  return (
    <Typography variant={variant} sx={styles}>
      {children}
    </Typography>
  );
};

export default InfoItemLabel;
